import { RouteType } from "types/RouteType";
import modulesRoute from "./ModuleList/modules.Route";
import moduleDetailRoute from "./ModuleDetail/moduleDetail.Route";

/**
 * Routes for the Modules (Module 360) feature area, composed into
 * `src/views/routesList.tsx` by the integrator.
 *
 * The hidden `ModuleDetail` route (`/modules/:slug/:tab?`) is spread in here
 * too — its list route navigates to it by NAME
 * (`routerStore.goTo("ModuleDetail", { slug })`), which is how `ClientDetail`
 * is reached today and needs no import between the two.
 */
const modulesRoutesList: RouteType[] = [...modulesRoute, ...moduleDetailRoute];

export default modulesRoutesList;
